import React from "react";
import { Empty } from "antd";

// PD-2336: placeholder only -- Contra Report has no backing UI or data yet (the domain concept
// exists as BILLING_TYPE.CONTRA_COD in constants/billing.js, but no report has been built).
// Replace this with the real report once that work is scoped.
const ContraReport = () => (
  <Empty description="Contra Report is coming soon" style={{ marginTop: 48 }} />
);

export default ContraReport;
